import { IBaseSettings } from '$/types'
import { RootState } from 'app/store'

import { IEventAttribute, IPopupNotification } from './types'

export const selectBaseSettings = (state: RootState): IBaseSettings[] =>
  state.settings.baseSettings

export const selectEventAttributes = (state: RootState): IEventAttribute[] =>
  state.settings.eventAttributes

export const selectPopupNotification = (
  state: RootState
): IPopupNotification | undefined => state.settings.popupNotification
